import React from "react";

const PreferencesSettings = () => {
  return (
    <div>
      <h5>Preferences</h5>

      <p className="text-muted">
        Configure your POS user preferences.
      </p>

      <div className="alert alert-info">
        <i className="bi bi-info-circle me-2"></i>

        Preference options will be added here.
      </div>
    </div>
  );
};

export default PreferencesSettings;